import Box from 'fe-design-base/atoms/Box';
import Icon, { IconName } from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import Avatar from 'fe-design-base/molecules/Avatar';
import Pill from 'fe-design-base/molecules/Pill';
import { PillVariant } from 'fe-design-base/molecules/Pill/Pill';

import { initials } from 'features/notifications/utils';

import { toI18n } from 'util/i18n';

type Status = 'no_reply' | 'declined' | 'no_answer';

type Reason = {
  icon: IconName;
  message: string;
};

type Invited = {
  id: string;
  accepter: {
    first_name: string;
    last_name: string;
    avatar_url: string;
  };
  reasons?: Reason[];
  state?: Status;
};

type CoverInvitedCardProps = {
  user: Invited;
};

const statuses: Record<Status, { label: string; variant: PillVariant }> = {
  no_reply: {
    label: toI18n('requests_feed.statuses.no_reply'),
    variant: 'warning',
  },
  declined: {
    label: toI18n('requests_feed.statuses.declined'),
    variant: 'error',
  },
  no_answer: {
    label: toI18n('requests_feed.statuses.no_answer'),
    variant: 'warning',
  },
};

const CoverInvitedCard = ({ user }: CoverInvitedCardProps) => {
  const { reasons, state, accepter } = user;
  const { first_name, last_name, avatar_url: avatar } = accepter;
  const name = `${first_name} ${last_name}`;
  const currentStatus = state || 'no_reply';
  return (
    <Box
      p={16}
      bw={1}
      bcolor="mono300"
      bradiusm
      row
      justifyContentSpaceBetween
      alignItemsCenter
    >
      <Box row gap={16} alignItemsCenter>
        <Avatar image={avatar} initials={initials(name)} size="large" />
        <Box column gap={4} grow={1}>
          <Text variant="bodyBoldTight">{name}</Text>
          {reasons?.map(reason => (
            <Box key={reason.message} row gap={4} alignItemsCenter>
              <Icon iconName={reason.icon} size="small" />
              <Text variant="bodySm" color="mono700">
                {reason.message}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
      <Pill variant={statuses[currentStatus as Status].variant}>
        {statuses[currentStatus as Status].label}
      </Pill>
    </Box>
  );
};

export default CoverInvitedCard;
